import { persistor } from 'store';
import * as SessionAnalyticsService from 'services/SessionAnalyticsService/SessionAnalyticsService';
import { handleError } from 'services/ErrorService/ErrorService';
import makeCloudFunctionRequest from './makeCloudFunctionRequest';
import AuthService from 'services/authService';
import { clearData } from '@asurion-core/frontend-utils/lib/WebObservability';
import environment from '../environment';

export const logout = async () => {
  localStorage.removeItem('sessionWarningShown');

  if (environment.observability.isTelemetryEnabled) {
    clearData();
  }

  const currentUser = AuthService.current();
  if (!currentUser) {
    window.location.href = '/';

    return;
  }

  try {
    if (currentUser.simplrExpert) {
      SessionAnalyticsService.event('User Logged Out', {
        user: currentUser.simplrExpert.id,
      });
    }

    persistor.purge();

    await AuthService.logout();
    window.location.href = '/';
  } catch (error) {
    handleError({ error, customMessage: 'Error while calling parse logout' });
    window.location.href = '/';
  }
};

export const isUserAnAdmin = async () => {
  const response = await makeCloudFunctionRequest('isUserAnAdmin');

  return response.isAdmin;
};

export const isAssignedExpert = async (conversationId) => {
  try {
    const { isExpertAssignedToConversation } = await makeCloudFunctionRequest('isExpertAssignedToConversation', {
      conversationId,
    });

    return isExpertAssignedToConversation;
  } catch (error) {
    handleError({ error, customMessage: 'Error while calling isExpertAssignedToConversation' });
  }

  return false;
};

export const isUserSuperAdmin = async () => {
  let response = false;
  try {
    response = await makeCloudFunctionRequest('isUserASuperAdmin');
  } catch (error) {
    handleError({ error, customMessage: 'Error while calling parse isUserSuperAdmin' });
  }

  return response;
};

export const isUserSpecialistLite = async () => {
  let response = false;
  try {
    response = await makeCloudFunctionRequest('isUserSpecialistLite');
  } catch (error) {
    handleError({ error, customMessage: 'Error while calling isUserSpecialistLite' });
  }

  return response;
};

export const isUserAPartnerProtector = async () => {
  let response = false;
  try {
    response = await makeCloudFunctionRequest('isUserAPartnerProtector');
  } catch (error) {
    handleError({ error, customMessage: 'Error while calling isUserAPartnerProtector' });
  }

  return response;
};
